import { render, staticRenderFns } from "./QueryChocostickI.vue?vue&type=template&id=65e22546&"
import script from "./QueryChocostickI.vue?vue&type=script&lang=js&"
export * from "./QueryChocostickI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports